module.exports = __webpack_public_path__ + "icon2.2b91d86f.gif";